// dependancies
import React from "reactn";
import PropTypes from "prop-types";
import DeliveryStatusLabelStyled from "./DeliveryStatusLabel.styled";

const DeliveryStatusLabel = ({ status, classes }) => {
	const getDeliveryStatusInfo = status => {
        switch (status) {
            case "0":
                return {
                    labelText: "In Transit",
                    statusClass: "orange"
                }
            case "1":
                return {
                    labelText: "Customs",
                    statusClass: "gold"
                }
            case "2":
                return {
                    labelText: "Accepted",
                    statusClass: "blue"
                }
            case "3":
                return {
                    labelText: "Sorting",
                    statusClass: "orange"
                }
            case "4":
                return {
                    labelText: "Delivered",
                    statusClass: "green"
                }
            case "5":
                return {
                    labelText: "Not delivered",
                    statusClass: "red"
                }
            case "6":
                return {
                    labelText: "Return to sender",
                    statusClass: "blue"
                }
            case "7":
                return {
                    labelText: "Info received",
                    statusClass: "blue"
                }
            default:
                return {
                    labelText: "",
                    statusClass: ""
                }
        }
    };
	
	const { labelText } = getDeliveryStatusInfo(status);
	return <DeliveryStatusLabelStyled className={`status ${getDeliveryStatusInfo(status).statusClass}`}>
		<span>{labelText}</span>
	</DeliveryStatusLabelStyled>;
};

DeliveryStatusLabel.propTypes = {
	status: PropTypes.string
};

export default DeliveryStatusLabel;
